export enum DatepickerPlacement {
  top = 'top',
  bottom = 'bottom',
  left = 'left',
  right = 'right'
}
